import { useSelector } from 'react-redux';
import MetaDecorator from 'components/layout/MetaDecorator';
import { useGetContactPageQuery, useGetPopularArticlesQuery } from 'app/api/gatewayApiSlice';
import LoaderSpinner from 'components/atoms/Loader/LoaderSpinner';
import ContactHero from './ContactHero';
import ContactResources from './ContactResources';
import ContactArticles from './ContactArticles';
import ContactForm from './ContactForm';
import './contactPage.scss';

export function ContactPage() {
  const { data: contactPageData, isLoading: isLoadingContactPage } = useGetContactPageQuery();
  const data = contactPageData?.sections;
  const user = useSelector((state) => state.user.userInfo);
  const { data: articles = [], isLoading } = useGetPopularArticlesQuery();

  if (isLoadingContactPage || !data) {
    return <LoaderSpinner />;
  }

  return (
    <>
      <MetaDecorator
        domain={process.env.REACT_APP_PUBLIC_URL}
        title='Contact Us'
        description='Find quick answers, onboarding resources, and support information for Roland Cloud.'
        link='contact-us'
      />

      <div className='min-h-screen md:pb-[4%] pb-[10%]'>
        <div className={`mx-auto max-w-[1080px] bg-white px-[20px] ${data.overviewVideo?.enabled ? 'pb-[80px]' : ''}`}>
          <ContactHero
            data={data.hero}
            overviewVideo={data.overviewVideo}
          />

        </div>
        <div className='px-[20px] md:px-[56px]'>
          <ContactResources data={data.featuredVideos} />
          <ContactArticles data={articles?.results} isLoading={isLoading} />
          <ContactForm data={data.contactForm} isLoggedIn={!!user && !user.guest} />
        </div>
      </div>
    </>
  );
}
